function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}
  if ($(window).width() < 1024) {
     $('.sticky-button').css('position', 'fixed');
  }

$(window).scroll(function() {
    //After scrolling 300px from the top...
  if ($(window).width() < 1024) {
    if ( $(window).scrollTop() <= 600 || $(window).scrollTop() >= 1100 ) {
        $('.sticky-button').css('position', 'fixed');

    //Otherwise remove inline styles and thereby revert to original stying
    } else {
        $('.sticky-button').attr('style', '');

    }

    if ( $(window).scrollTop()){
        $('.sticky-image').css('top', '0');
        $('.sticky-image').css('position', 'fixed');
        $('.sticky-image').css('width', '100%');      
        $('.sticky-image').css('left', '12px');   
        $('.sticky-image').css('z-index', '1');      

    //Otherwise remove inline styles and thereby revert to original stying
    }
      else{
        $('.sticky-image').attr('style', '');    
        $('.sticky-image').css('width', '100%'); 
        $('.sticky-image').css('left', '0px');    
        $('.sticky-image').css('display', 'block !important');        
    }

  }
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute("role", "button");
    summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

    if (summary.nextElementSibling.getAttribute("id")) {
        summary.setAttribute("aria-controls", summary.nextElementSibling.id);
    }

    summary.addEventListener("click", (event) => {
        event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    });

    if (summary.closest("header-drawer")) return;
    summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);

    elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(":focus-visible");
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        "ARROWUP",
        "ARROWDOWN",
        "ARROWLEFT",
        "ARROWRIGHT",
        "TAB",
        "ENTER",
        "SPACE",
        "ESCAPE",
        "HOME",
        "END",
        "PAGEUP",
        "PAGEDOWN",
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener("keydown", (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener("mousedown", (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        "focus",
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add("focused");
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
    });
    document.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
    });
    document.querySelectorAll("video").forEach((video) => video.pause());
    document.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open");
    summaryElement.setAttribute("aria-expanded", false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: `application/${type}` },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

    Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector("details");

        if (navigator.platform === "iPhone")
            document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

        this.addEventListener("keyup", this.onKeyUp.bind(this));
        this.addEventListener("focusout", this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll("summary").forEach((summary) =>
            summary.addEventListener("click", this.onSummaryClick.bind(this))
        );
        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onCloseButtonClick.bind(this))
        );
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== "ESCAPE") return;

        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle
            ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
            : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest(".has-submenu");
        const isOpen = detailsElement.hasAttribute("open");
        const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
            summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
          document.querySelector(".formSearch").style.display = "none";
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            setTimeout(() => {
                console.log("menu is opening inside1>>>>>>>>>>>>>>>>>>>>>>>>>>");
                detailsElement.classList.add("menu-opening");
                //document.querySelector(".formSearch").style.display = "none";
                summaryElement.setAttribute("aria-expanded", true);
                parentMenuElement && parentMenuElement.classList.add("submenu-open");
              
                !reducedMotion || reducedMotion.matches
                    ? addTrapFocus()
                    : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
         $("body").toggleClass("index_page");
         $(".header-wrapper").css("position", "");
         $(".header-wrapper").addClass("seee3");
        console.log("menu is opening inside2>>>>>>>>>>>>>>>>>>>>>>>>>>");
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        });
        //document.querySelector(".formSearch").style.display = "none";
        summaryElement.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;
        $("body").addClass('remove_overflow');
        console.log("menu is opening inside3>>>>>>>>>>>>>>>>>>>>>>>>>>");
        this.mainDetailsToggle.classList.remove("menu-opening");
        this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
            details.removeAttribute("open");
            details.classList.remove("menu-opening");
        });
        this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
          //  submenu.classList.remove("submenu-open");
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
        document.querySelector(".txtSearch").style.display = "block";
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest("details");
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest(".submenu-open");
       // parentMenuElement && parentMenuElement.classList.remove("submenu-open");
       // detailsElement.classList.remove("menu-opening");
        //detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
       // removeTrapFocus(detailsElement.querySelector("summary"));
       // this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define("menu-drawer", MenuDrawer);

let fullMenuHTML = "";

fetch('/pages/navigation-dropdown')
  .then(res => res.text())
  .then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const drawer = doc.querySelector('#menu-drawer-mobile');
  //  console.log(`drawer-innerHtml >>>>>>>: ${drawer.innerHTML}`);
    if (drawer) {
    //        console.log(`drawer-innerHtml >>>>>>>: ${drawer.innerHTML}`);
            fullMenuHTML = drawer.innerHTML;
    } else {
        console.log("drawer not found ❌");
    }
  })
  .catch(err => console.error(err));

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById("shopify-section-header");
        this.borderOffset =
            this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
                ? 1
                : 0;
        document.documentElement.style.setProperty(
            "--header-bottom-position",
            `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
        );
         this.header.classList.add("menu-open");

    console.log("drawer open>>>>>>>>>>>>>>>>>");
       
        setTimeout(() => {
            // 👇 global cache
              // ✅ WAIT FOR CACHE
    if (!fullMenuHTML) {
            console.log("Menu not loaded yet ⏳");
            return;
        }

        const parent = document.querySelector('.menu-drawer-content');
        if (!parent) return;

        // 1️⃣ Append AJAX content first
        parent.innerHTML = fullMenuHTML;

        // 2️⃣ Select main drawer AFTER insert
        const mainDrawer = parent.querySelector('.menu-drawer__main-jtpl');
        if (!mainDrawer) return;

        // 3️⃣ Set initial off-screen translate and transition
        mainDrawer.style.translate = '-100% 0';
        mainDrawer.style.transition = 'translate 0.5s ease-in-out';

        // 4️⃣ Force reflow to trigger transition
        mainDrawer.offsetHeight;

        // 5️⃣ Set translate to 0 → triggers smooth slide-in
        if (window.innerWidth <= 989) {
            mainDrawer.style.translate = '0 0';
        } else {
            mainDrawer.style.translate = '-100% 0'; // desktop default
        }

        // 6️⃣ Show parent drawer
        const drawer = parent.querySelector(".menu-drawer");
        if (drawer) {
            drawer.style.visibility = "visible";
            drawer.style.display = "block";
            drawer.style.opacity = "1";
        }


$(document).on('click', '.disclosure__item a', function(e) {
          
          e.preventDefault();
          e.stopImmediatePropagation(); // 🔥 IMPORTANT (Shopify ko rokega)
          console.log(`clicked ogya country selector`);
          let form = $(this).closest('form');
          let countryCode = $(this).data('value');

          form.find('input[name="country_code"]').val(countryCode);

          let realURL = window.location.href.split('?')[0];
          console.log("REAL URL:", realURL);

          form.find('input[name="return_to"]').val(realURL);

          form[0].submit();
      });
$('.disclosure__button').click(function() {
    $(".disclosure__list").toggleClass("active");
    $('.header__icon').attr('aria-expanded', 'true');
})

    $('.main_back_btn').click(function(){
    $(this).parents('.megaDrawer').find('input').prop('checked',false);
  });
        });

        summaryElement.setAttribute("aria-expanded", true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove("menu-open");
    }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
        this.addEventListener("keyup", (event) => {
             console.log("modal clicked?????????????");
            if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
        if (this.classList.contains("media-modal")) {
             console.log("modal clicked?????????????");
            this.addEventListener("pointerup", (event) => {
                if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
                    this.hide();
            });
        } else {
            this.addEventListener("click", (event) => {
                console.log("modal clicked?????????????");
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden");
        this.setAttribute("open", "");
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove("overflow-hidden");
        document.body.dispatchEvent(new CustomEvent("modalClosed"));
        this.removeAttribute("open");
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector("button");

        if (!button) return;
        button.addEventListener("click", () => {
            const modal = document.querySelector(this.getAttribute("data-modal"));
            if (modal) modal.show(button);
        });
    }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener("click", this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute("loaded")) {
            const content = document.createElement("div");
            content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

            this.setAttribute("loaded", true);
            const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
            if (focus) deferredElement.focus();
        }
    }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector(".slider-counter--current");
        this.pageTotalElement = this.querySelector(".slider-counter--total");
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener("scroll", this.update.bind(this));
        this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
        this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent("slideChanged", {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1],
                    },
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute("disabled", "disabled");
        } else {
            this.prevButton.removeAttribute("disabled");
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute("disabled", "disabled");
        } else {
            this.nextButton.removeAttribute("disabled");
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (
            element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === "next"
                ? this.slider.scrollLeft + step * this.sliderItemOffset
                : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector(".slider-buttons");
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
        this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
    }

    setAutoPlay() {
        this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
        this.autoplaySpeed = this.slider.dataset.speed * 1000;

        this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
        this.addEventListener("mouseover", this.focusInHandling.bind(this));
        this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
        this.addEventListener("focusin", this.focusInHandling.bind(this));
        this.addEventListener("focusout", this.focusOutHandling.bind(this));

        this.play();
        this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) return;

        if (isFirstSlide && event.currentTarget.name === "previous") {
            this.slideScrollPosition =
                this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === "next") {
            this.slideScrollPosition = 0;
        }
        this.slider.scrollTo({
            left: this.slideScrollPosition,
        });
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
        this.prevButton.removeAttribute("disabled");

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove("slider-counter__link--active");
            link.removeAttribute("aria-current");
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
        this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        const focusedOnAutoplayButton =
            event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
        this.play();
    }

    focusInHandling(event) {
        const focusedOnAutoplayButton =
            event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
        if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
            this.play();
        } else if (this.autoplayButtonIsSetToPlay) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute("aria-live", "off");
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute("aria-live", "polite");
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
            this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition =
            this.currentPage === this.sliderItems.length
                ? 0
                : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }

    setSlideVisibility() {
        this.sliderItemsToShow.forEach((item, index) => {
            const button = item.querySelector("a");
            if (index === this.currentPage - 1) {
                if (button) button.removeAttribute("tabindex");
                item.setAttribute("aria-hidden", "false");
                item.removeAttribute("tabindex");
            } else {
                if (button) button.setAttribute("tabindex", "-1");
                item.setAttribute("aria-hidden", "true");
                item.setAttribute("tabindex", "-1");
            }
        });
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
                (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }
}

customElements.define("slideshow-component", SlideshowComponent);

let extraCustomizationOpen = false;

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        const extraStone = document.querySelectorAll(".stone-quality label, .stone-size label");
        const othersInputs = document.querySelectorAll(
            ".variant-slider-fieldset label, .variant-slider-fieldset select"
        );
        extraStone.forEach((stone) => {
            stone.addEventListener("click", () => {
                this.removeEventListener("change", this.onVariantChange);
            });
        });
        othersInputs.forEach((stone) => {
            stone.addEventListener("click", () => {
                localStorage.removeItem("currentVariant");
                this.addEventListener("change", this.onVariantChange);
            });
        });
        this.addEventListener("change", this.onVariantChange);
    }
    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();

        if (!this.currentVariant) {
            this.toggleAddButton(true, "", "", true);
            this.setUnavailable();
        } else {
            //this.updateMedia();

            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
    }

    updateMasterId() {
        let currentVariantStorage = JSON.parse(localStorage.getItem("currentVariant"));
        if (currentVariantStorage && this.classList.value.includes("extraVariant")) {
            console.log("ok");
            this.currentVariant = currentVariantStorage;
        } else {
            this.currentVariant = this.getVariantData().find((variant) => {
                return !variant.options
                    .map((option, index) => {
                        return this.options[index] === option;
                    })
                    .includes(false);
            });
            localStorage.setItem("currentVariant", JSON.stringify(this.currentVariant));
        }
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
        mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

        const modalContent = document.querySelector(
            `#ProductModal-${this.dataset.section} .product-media-modal__content`
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        let productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", { bubbles: true }));
        });
    }
    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
                this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
            }`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(
                    `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                if (source && destination) destination.innerHTML = source.innerHTML;

                const price = document.getElementById(`price-${this.dataset.section}`);
                let priceAmount = price.querySelector(".price-item").textContent;
              
                if (price) price.classList.remove("visibility-hidden");
                this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, priceAmount);
              

              
            });
    }

    toggleAddButton(disable = true, text, priceAmount, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute("disabled");
            addButtonText.textContent = `${window.variantStrings.addToCart} | ${priceAmount}`;
        }

        if (!modifyClass) return;
    }
 
  

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add("visibility-hidden");
    }

    getVariantData() {
        if (this.classList.value.includes("extraVariant")) {
            this.variantData =
                this.variantData ||
                JSON.parse(
                    document.querySelector("variant-slider").querySelector('[type="application/json"]').textContent
                );
        } else {
            this.variantData =
                this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        }
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
        });
    }
}

customElements.define("variant-radios", VariantRadios);

class VariantSlider extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll(".variant-slider-fieldset"));
        this.options = fieldsets.map((fieldset) => {
            let inputs = Array.from(fieldset.querySelectorAll("input, select"));
            let selectedInputs = inputs.find((input) => (input.checked == undefined ? input : input.checked));
            let legends = fieldset.querySelectorAll(`#select-${selectedInputs.getAttribute("data_name")}`);
          
            legends.forEach(function(legend){
                legend
                ? legend.id.includes(`select-${selectedInputs.getAttribute("data_name")}`)
                    ? (legend.textContent = selectedInputs.value)
                    : null
                : null;
            })
            
            return selectedInputs.value;
        });
        //this.updateGemstone(this.options);
    }

    updateGemstone(options) {
        const gemOptions = JSON.parse(document.getElementById("variantsProd").textContent); // product options
        const gemstone = options[0]; // selected gemstone option
        const gemstoneGeneral = document.getElementById("banner-gemstone-general");
        const gemstoneDiamond = document.getElementById("banner-gemstone-black-diamond");
        const dinamicTitle = document.getElementById("dinamic-title"); // banner title
        const dinamicImgBanner = document.getElementById("dinamic-img-banner"); // banner img
        const dinamicQualityExtCustomImgs = document.querySelectorAll(".quality_extra_customization_img"); // extra customization img

        // change imgs function
        const changeImgs = (images) => {
            images.forEach((img) => {
                const src = img.getAttribute("src");
                gemOptions.some((element) => {
                    element = element.trim().replace(" ", "");
                    if (src.includes(element)) {
                        img.setAttribute("src", `${src.replace(element, gemstone.trim().replace(" ", ""))}`);
                    }
                });
            });
        };

        // change banner img
        if (dinamicImgBanner) {
            const src = dinamicImgBanner.getAttribute("src");
            gemOptions.some((element) => {
                element = element.trim().replace(" ", "");
                if (src.includes(element)) {
                    dinamicImgBanner.setAttribute(
                        "src",
                        `${src.replace(element, gemstone.trim().replace(" ", ""))}Banner.png`
                    );
                }
            });
        }

        //extra customization
        if (dinamicQualityExtCustomImgs) changeImgs(dinamicQualityExtCustomImgs);

        const dinamicColorTitle = gemstoneGeneral.querySelector("#banner_color_title_dinamic");
        const dinamicColorImages = gemstoneGeneral.querySelectorAll(".banner_color_img");
        const dinamicBgDegrade = gemstoneGeneral.querySelector(".banner_color_degrade");
        const dinamicSizeImg = gemstoneGeneral.querySelectorAll(".banner_size_img");
        const dinamicQualityImages = gemstoneGeneral.querySelectorAll(".banner_quality_img");
        if (dinamicColorTitle != null) dinamicColorTitle.innerText = gemstone;
        changeImgs(dinamicColorImages);
        changeImgs(dinamicSizeImg);
        changeImgs(dinamicQualityImages);
        if (dinamicBgDegrade != null)
            dinamicBgDegrade.setAttribute("class", `banner_color_degrade banner_${gemstone}_bg`);
        /*
    if(gemstone == 'Black Diamond'){
      if(gemstoneDiamond) gemstoneDiamond.style.display='flex'
      if(gemstoneGeneral) {gemstoneGeneral.style.display='none'
        const dinamicSizeImg=gemstoneDiamond.querySelectorAll('.banner_diamond_size_img')
        changeImgs(dinamicSizeImg)
      }
      if(dinamicTitle) dinamicTitle.innerText ='The Four C’s of Your Diamond'
      
    }else{
      if(gemstoneDiamond) gemstoneDiamond.style.display='none'
      if(gemstoneGeneral) {
        gemstoneGeneral.style.display='flex'
        const dinamicColorTitle = gemstoneGeneral.querySelector('#banner_color_title_dinamic')
        const dinamicColorImages = gemstoneGeneral.querySelectorAll('.banner_color_img')
        const dinamicBgDegrade = gemstoneGeneral.querySelector('.banner_color_degrade')
        const dinamicSizeImg = gemstoneGeneral.querySelectorAll('.banner_size_img')
        const dinamicQualityImages = gemstoneGeneral.querySelectorAll('.banner_quality_img')
        dinamicColorTitle.innerText = gemstone
        changeImgs(dinamicColorImages)
        changeImgs(dinamicSizeImg)
        changeImgs(dinamicQualityImages)
        dinamicBgDegrade.setAttribute('class', `banner_color_degrade banner_${gemstone}_bg`)
      }
      if(dinamicTitle) dinamicTitle.innerText =`Understanding Your ${gemstone} Unique Characteristics`
    }
    */
    }
}

customElements.define("variant-slider", VariantSlider);

class VariantExtraCustomization extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll(".variant-slider-fieldset"));
        this.options = fieldsets.map((fieldset) => {
            let inputs = Array.from(fieldset.querySelectorAll("input, select"));
            let selectedInputs = inputs.find((input) => (input.checked == undefined ? input : input.checked));
            let legends = fieldset.querySelectorAll(`#select-${selectedInputs.getAttribute("data_name")}`);
            legends.forEach(function(legend){
                legend
                ? legend.id.includes(`select-${selectedInputs.name}`)
                    ? (legend.textContent = selectedInputs.value)
                    : null
                : null;
            })
            
            return selectedInputs.value;
        });
    }
}

customElements.define("variant-extra-customization", VariantExtraCustomization);

//productModals

const clickEvent = new Event("click");
const submitEvent = new Event("submit");
const openEngravingModalBtn = document.getElementById("engraving-open-modal");
const openExtraCustomizationModalBtn = document.getElementById("extra_customization-open-modal");
const openExtraCustomizationModalActiveBtn = document.getElementById("extra_customization-open-modal-active");
const engravingModal = document.getElementById("engraving-modal");
const extraCustomizationModal = document.getElementById("extra_customization-modal");
const closeExtraCustomizationModalBtn = document.getElementById("extra_customization-modal-close");
const closeEngravingModalBtn = document.getElementById("engraving-modal-close");
const engraveForm = document.getElementById("engrave-form");
const engraveText = document.getElementById("engraving-text-modal");
const engraveText1 = document.getElementById("engraving-text-modal1");
const engraveFont = document.querySelectorAll('input[name="attributes[engraving-font-modal]"]');
const engraveFontBack = document.querySelectorAll('input[name="attributes[engraving-font-modal-back]"]');
const engraveTextMainProd = document.getElementById("engraving-text-main-prod");
const engraveTextMainProd1 = document.getElementById("engraving-text-main-prod1");
const engraveFontMainProd = document.getElementById("engraving-font");
const engraveBackFont = document.getElementById("back-engraving-font");
const engraveTextExtranProd = document.getElementById("engraving-text-extra-prod");
const engraveFontExtraProd = document.getElementById("engraving-extra-font");
const errorTextEngrave = document.getElementById("errorTextEngrave");
if (openEngravingModalBtn != null) {
    openEngravingModalBtn.addEventListener("click", function (e) {
        e.preventDefault();
        engravingModal.classList.add("engraving-modal-active");
    });
}
if (closeEngravingModalBtn != null) {
    closeEngravingModalBtn.addEventListener("click", function (e) {
        e.preventDefault();
        engravingModal.classList.remove("engraving-modal-active");
    });
}
if(engraveForm != null){
engraveForm.addEventListener("submit", (event) => {
    event.preventDefault();
    if ($('.front_image_box .engraving_text').text() == ' ' && $('.back_image_box .engraving_text').text() == ' ' ) {
        errorTextEngrave.textContent = "Text can't be empty";
        return;
    }

    engraveTextMainProd.value = $('.front_image_box .engraving_text').text();

    if (engraveTextExtranProd != null) {
        engraveTextExtranProd.value = $('.front_image_box .engraving_text').text();
    }
if (typeof engraveText1 !== 'undefined' && engraveText1 !== null) {
    if (typeof engraveTextMainProd1 !== 'undefined' && engraveTextMainProd1 !== null) {
        engraveTextMainProd1.value = $('.back_image_box .engraving_text').text();
    } 
} 


    engraveFont.forEach((font) => {
        if (font.checked) {
            engraveFontMainProd.value = font.value;
              if (engraveFontExtraProd != null) {
                engraveFontExtraProd.value = font.value;
            }
        }
    });
  engraveFontBack.forEach((font) => {
        if (font.checked) {
            engraveBackFont.value = font.value;
          if (engraveBackFont != null) {
                engraveBackFont.value = font.value;
            }
        }
    });
  
    closeEngravingModalBtn.dispatchEvent(new Event("click"));
  if (
    typeof engraveTextMainProd !== 'undefined' && engraveTextMainProd.value.trim() !== '' &&
    typeof engraveTextMainProd1 !== 'undefined' && engraveTextMainProd1.value.trim() !== ''
) {
    openEngravingModalBtn.textContent = `Edit engrave. ( Front Text: ${$('.front_image_box .engraving_text').text()}, Back Text: ${$('.back_image_box .engraving_text').text()}, Front Font: ${engraveFontMainProd.value}, Back Font: ${engraveBackFont.value})`;
} else {
    openEngravingModalBtn.textContent = `Edit engrave. ( Text: ${$('.front_image_box .engraving_text').text()}, Font: ${engraveFontMainProd.value})`;
}

    localStorage.setItem("EngraveEnable", true);

    let emitter = window.emitter;
    emitter.emit("engraveChange", {
    engraveText: $('.front_image_box .engraving_text').text(),
    engraveFont: engraveFontMainProd.value,
    engraveBackText:$('.back_image_box .engraving_text').text(),
    engraveBackFont:engraveBackFont.value,
    });
});
}
if (openExtraCustomizationModalActiveBtn != null) {
    openExtraCustomizationModalActiveBtn.addEventListener("click", function (e) {
        e.preventDefault();
    });
}

if (openExtraCustomizationModalBtn != null) {
    openExtraCustomizationModalBtn.addEventListener("click", function (e) {
        e.preventDefault();
        extraCustomizationOpen = true;
        extraCustomizationModal.classList.add("extra_customization-modal-active");
        $('.main-prod-slick2').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          });
    });
}

if (closeExtraCustomizationModalBtn != null) {
    closeExtraCustomizationModalBtn.addEventListener("click", function (e) {
        e.preventDefault();
        extraCustomizationOpen = false;
        extraCustomizationModal.classList.remove("extra_customization-modal-active");
    });
}

const engravingExtraBtn = document.getElementById("engraving-open-modal-extra");
if (engravingExtraBtn) {
    engravingExtraBtn.addEventListener("click", (e) => {
        e.preventDefault();
        openEngravingModalBtn.dispatchEvent(clickEvent);
    });
}

const radioButtons = document.querySelectorAll('input[name="properties[Stone Size]"');
const spanRadioStar = document.querySelectorAll(".stone-size-label");
const spanDinamic = document.getElementById("select-stone-size");
radioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
        spanDinamic.textContent = radio.value;
        spanRadioStar.forEach((span) => {
            span.classList.add("regularBorder");
            span.classList.remove("checkedBorder");
        });
        const spanRadio = radio.parentElement.querySelector(`.${radio.id}`);
        spanRadio.classList.add("checkedBorder");
    });
    if (radio.checked) {
        const checkedSpan = radio.parentElement.querySelector(`.${radio.id}`);
        checkedSpan.classList.add("checkedBorder");
    }
});

const addToCartExtra = document.getElementById("extra-customization-add-to-cart-button");
if (addToCartExtra) {
    addToCartExtra.addEventListener("click", () => {
        closeExtraCustomizationModalBtn.dispatchEvent(new Event("click"));
    });
}
const mediaBtn = document.querySelectorAll(".product__media-toggle");
const productModalImgs = document.querySelectorAll("product-modal img");
mediaBtn.forEach((btn) => {
    btn.addEventListener("click", () => {
        const data = btn.getAttribute("data-media-id");
        productModalImgs.forEach((img) => {
            if (img.getAttribute("data-media-id") != data) {
                img.style.display = "none";
            } else {
                img.style.display = "block";
            }
        });
    });
});

const wishlistPdp = document.querySelector(".wishlist-heart");
const wishlistAddedPdp = document.querySelector(".wishlist-heart-added");
const btnPdpWishlist = document.getElementById("btn-pdp-wishlist");
const wishlistPdpExtra = document.querySelector(".wishlist-heart-extra");
const wishlistAddedPdpExtra = document.querySelector(".wishlist-heart-added-extra");
const btnPdpWishlistExtra = document.getElementById("btn-pdp-wishlist-extra");
if(wishlistAddedPdp){
    wishlistAddedPdp.style.display = "none";
}
if(wishlistAddedPdpExtra){
    wishlistAddedPdpExtra.style.display = "none";
}
if(wishlistPdp){
    wishlistPdp.style.display = "none";
}

if(wishlistAddedPdp) wishlistAddedPdp.style.display = "none";
if(wishlistPdp) wishlistPdp.style.display = "none";
if(wishlistAddedPdpExtra) wishlistAddedPdpExtra.style.display = "none";
if(wishlistPdpExtra) wishlistPdpExtra.style.display = "none";

setTimeout(() => {
    if (btnPdpWishlist && wishlistAddedPdp != null) {
        if (btnPdpWishlist.className.includes("swym-added")) {
            if(wishlistAddedPdp) wishlistAddedPdp.style.display = "block";
            wishlistPdp.style.display = "none";
            wishlistAddedPdpExtra.style.display = "block";
            wishlistPdpExtra.style.display = "none";
        } else {
            wishlistAddedPdp.style.display = "none";
            wishlistPdp.style.display = "block";
            if(wishlistAddedPdpExtra) wishlistAddedPdpExtra.style.display = "none";
            wishlistPdpExtra.style.display = "block";
        }
    }
}, 3000);
if (wishlistPdp) {
    wishlistPdp.addEventListener("click", () => {
        if (btnPdpWishlist) {
            btnPdpWishlist.dispatchEvent(new Event("click"));
            if (wishlistAddedPdp) {
                wishlistAddedPdp.style.display = "block";
                wishlistPdp.style.display = "none";
                wishlistAddedPdpExtra.style.display = "block";
                wishlistPdpExtra.style.display = "none";
            }
        }
    });
    wishlistAddedPdp.addEventListener("click", () => {
        if (btnPdpWishlist) {
            btnPdpWishlist.dispatchEvent(new Event("click"));
            if (wishlistAddedPdp) {
                wishlistAddedPdp.style.display = "none";
                wishlistPdp.style.display = "block";
                wishlistAddedPdpExtra.style.display = "none";
                wishlistPdpExtra.style.display = "block";
            }
        }
    });
    
    wishlistPdpExtra.addEventListener("click", () => {
        if (btnPdpWishlistExtra) {
            btnPdpWishlistExtra.dispatchEvent(new Event("click"));
            if (wishlistAddedPdp) {
                wishlistAddedPdp.style.display = "block";
                wishlistPdp.style.display = "none";
                wishlistAddedPdpExtra.style.display = "block";
                wishlistPdpExtra.style.display = "none";
            }
        }
    });
}
